import { render, staticRenderFns } from "./MyAccountUserGroups.vue?vue&type=template&id=8dd911ec"
import script from "./MyAccountUserGroups.vue?vue&type=script&lang=js"
export * from "./MyAccountUserGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports